import { cva, type VariantProps } from 'class-variance-authority';

/**
 * Root container variants for the dropzone surface. `dragOver` controls
 * the highlighted state (background tint + dashed border emphasis), and
 * `disabled` short-circuits hover and focus affordances.
 */
export const fileDropzoneVariants = cva(
  [
    'relative flex w-full flex-col items-center justify-center gap-sm',
    'rounded-md border-2 border-dashed border-neutral-200 bg-white',
    'px-lg py-2xl text-center text-neutral-900',
    'transition-colors duration-200',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500',
  ],
  {
    variants: {
      dragOver: {
        true: 'border-primary-500 bg-primary-50',
        false: '',
      },
      disabled: {
        true: 'cursor-not-allowed bg-neutral-50 text-subtext',
        false: 'cursor-pointer hover:border-neutral-500',
      },
    },
    defaultVariants: {
      dragOver: false,
      disabled: false,
    },
  },
);

export const fileDropzonePromptVariants = cva('text-b4 font-bold', {
  variants: {
    variant: {
      default: '',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export const fileDropzoneHintVariants = cva('text-b5 text-subtext', {
  variants: {
    variant: {
      default: '',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type FileDropzoneVariantProps = VariantProps<
  typeof fileDropzoneVariants
>;
export type FileDropzonePromptVariantProps = VariantProps<
  typeof fileDropzonePromptVariants
>;
export type FileDropzoneHintVariantProps = VariantProps<
  typeof fileDropzoneHintVariants
>;
